import { type RefObject, useEffect, useRef } from 'react';

/** Back from a step returns focus to the control that opened it, once the step has unmounted. */
export const useReturnFocus = (inStep: boolean, openerRef: RefObject<HTMLElement | null>) => {
  const wasInStep = useRef(inStep);

  useEffect(() => {
    if (wasInStep.current && !inStep) openerRef.current?.focus();
    wasInStep.current = inStep;
  }, [inStep, openerRef]);
};
